// extracted by mini-css-extract-plugin
export default {"main":"header_main__9lq24","inner_main":"header_inner_main__417HA","hover_text":"header_hover_text__fIzvi","hover_text2":"header_hover_text2__5Lva1"};